import { Component, OnInit } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Component({
  	selector: 'app-toolcards-learning-cycle',
  	templateUrl: './toolcards-learning-cycle.component.html',
  	styleUrls: ['./toolcards-learning-cycle.component.scss']
})
export class ToolcardsLearningCycleComponent implements OnInit {
	public env;

  	constructor() { }

  	ngOnInit() {
  		this.env=environment;
  	}

}
